import { Component } from '@angular/core';

@Component({
  selector: 'app-contratos-processos',
  templateUrl: './processos.component.html',
  styleUrl: './processos.component.css'
})
export class ContratosProcessosComponent {

}
